import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const MailingsPage = lazy(() => import("./MailingsPage"));
const MailingComposePage = lazy(() => import("./MailingComposePage"));
const MailingHistoryPage = lazy(() => import("./MailingHistoryPage"));

// Member-facing mailings (K&V Epic 3, #84); gated on the Distributions
// module like the distribution routes (see routes.tsx)
const mailingsRoutes: RouteObject[] = [
  {
    path: "/mailings",
    element: (
      <Suspense fallback={<Loading />}>
        <MailingsPage />
      </Suspense>
    ),
  },
  {
    path: "/mailings/new",
    element: (
      <Suspense fallback={<Loading />}>
        <MailingComposePage />
      </Suspense>
    ),
  },
  {
    path: "/mailings/:mailingId/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <MailingComposePage />
      </Suspense>
    ),
  },
  {
    path: "/mailings/:mailingId/history",
    element: (
      <Suspense fallback={<Loading />}>
        <MailingHistoryPage />
      </Suspense>
    ),
  },
];

export default mailingsRoutes;
